import Vue from 'vue';
import Vuex from 'vuex';

const initialState = {
  email: '',
  firstName: '',
  formFirstName: '',
  lastName: '',
  formLastName: '',
  phoneNumber: '',
  password: '',
  securityQuestion: '',
  securityAnswer: '',
  presetPhoneNumber: '',
  clubcardNumber: '',
  isQuickShopper: false,
  isFullShopper: false,
  agreeTerms: false,
  agreeComms: true,
  flybuysNumber: '',
  airpointsNumber: '',
  rewardType: 'none',
  flybuysOption: 'none',
  airpointsOption: 'none',
  title: '',
  gender: '',
  dateOfBirth: '',
  securityQuestions: [],
  resAddress: {
    isManual: false,
    address: '',
    pxid: '',
    manualAddress: {
      unit: '',
      streetNumber: '',
      streetName: '',
      deliveryServiceNumber: '',
      ruralDeliveryNumber: '',
      suburb: '',
      city: '',
      postcode: ''
    }
  },
  samePostalAddress: true,
  postAddress: {
    isManual: false,
    address: '',
    pxid: '',
    manualAddress: {
      unit: '',
      streetNumber: '',
      streetName: '',
      deliveryServiceNumber: '',
      ruralDeliveryNumber: '',
      suburb: '',
      city: '',
      postcode: ''
    }
  },
  scrolls: {},
  autologinParams: '',
  requireTitle: false
};

Vue.use(Vuex);
export const store = new Vuex.Store({
  state: initialState,
  mutations: {
    reset (state) {
      for (let key in state) {
        Vue.set(state, key, initialState[key]);
      }
    }
  },
  getters: {
    firstName: state => {
      return state.firstName || '';
    },
    hasFirstName: state => {
      return !!state.firstName;
    },
    hasLastName: state => {
      return !!state.lastName;
    }
  }
});



// WEBPACK FOOTER //
// ./src/store.ts